import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import config from 'src/assets/config.json';
import { environment } from 'src/environments/environment';
import { APIService } from './api.service';
import { UserSessionService } from './user-session.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private apiService: APIService,
    private userSessionService: UserSessionService
  ) {}
  /**
   * Service for login user
   *
   * @param {Object} urlParams
   */
  login(urlParams: any) {
    urlParams.client_id = environment.client_id;
    urlParams.project_id = environment.project_id;
    return this.apiService.post('/srv/auth/login', urlParams).pipe(
      map((res) => {
        this.userSessionService.setCurrentUser(res.session, res.response);
        localStorage.setItem('partner', 'Tabletbizz');
        localStorage.setItem('project', 'Admin');
        return res.response;
      })
    );
  }

  /**
   * Service for register user
   *
   * @param {Object} urlParams
   */
  register(urlParams: Object) {
    return this.apiService.post('/srv/auth/register', urlParams);
  }

  /**
   * Service for reset password or Update current passowrd
   *
   * @param {Object} urlParams
   */
  passwordReset(urlParams: Object) {
    return this.apiService.post('/srv/auth/passwordreset', urlParams);
  }

  /**
   * Service for update user "loginability" :)
   *
   * @param {Object} urlParams
   */
  updateLog(urlParams: Object) {
    return this.apiService.post('/srv/auth/updatelog', urlParams);
  }

  /**
   * Service for delete user registration
   *
   * @param {Object} urlParams
   */
  clearLog(urlParams: Object) {
    return this.apiService.post('/srv/auth/clearlog', urlParams);
  }

  /**
   * Service to logout current user
   *
   * @param {Object} urlParams
   */
  async logout(): Promise<void> {
    localStorage.clear();
    await this.apiService.post('/srv/auth/logout').toPromise();
    this.userSessionService.delCurrentUser();
  }

  get userLevel(): number {
    return this.userSessionService.currentUser.level;
  }
}
